import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientNoteEntity } from './client-note.entity';

/** PD-17132 — what a customer note can be linked to, besides its own columns. */
export const CLIENT_NOTE_LINK_ENTITY_TYPES = ['contact'] as const;

export type ClientNoteLinkEntityType = (typeof CLIENT_NOTE_LINK_ENTITY_TYPES)[number];

/**
 * PD-17132 — a customer note linked to a record it is about, many to many:
 * one note can name several people. The same shape as event_link (tasks),
 * issue_link and visit_link, so notes gain links the way the others do; for
 * now the people a note is about. The note's single columns (opportunity,
 * visit, job) stay as they are (the legacy CRM reads the opportunity one).
 *
 * SM1 exposure: none (a new table).
 */
@Index('client_note_link__note_entity', ['fkClientNoteId', 'entityType', 'entityId'], { unique: true })
@Index('client_note_link__entity', ['entityType', 'entityId'], {})
@Entity('client_note_link')
export class ClientNoteLinkEntity extends BaseEntity {
	@Column('int', { name: 'fk_client_note__id', unsigned: true })
	public fkClientNoteId!: number;

	@Column('varchar', { name: 'entityType', length: 32 })
	public entityType!: ClientNoteLinkEntityType;

	@Column('int', { name: 'entityId', unsigned: true })
	public entityId!: number;

	@ManyToOne(() => ClientNoteEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_client_note__id', referencedColumnName: 'id' }])
	public note!: ClientNoteEntity;
}
